import { Notify } from 'quasar'

export function useNotify(notifyMsg: string, timeout: number | null, notifyType = 'info', notifyCaption='') {
  const options = {
    type: notifyType,
    message: notifyMsg,
    ...(notifyCaption !== '' && { caption: notifyCaption }),
  }
  if (timeout) {
    Notify.create({
      ...options,
      ...{
        position: 'top',
        progress: true,
        timeout,
      }
    })
  } else {
    Notify.create({
      ...options,
      ...{
        position: 'top',
        actions: [
          {
            label: 'Dismiss',
            color: 'yellow',
            handler: () => {
              /* ... */
            },
          },
        ],
        timeout: 0,
      }
    })
  }
}
